import React, { useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { Package, MagnifyingGlass } from "@phosphor-icons/react";
import api from "../lib/api";
import { brl } from "../lib/format";
import LazyImage from "./LazyImage";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function ContractorProducts() {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products")
      .then(r => setItems(r.data))
      .catch(err => toast.error(err?.response?.data?.detail || "Erro ao carregar produtos"))
      .finally(() => setLoading(false));
  }, []);

  const visible = useMemo(() => {
    const f = search.trim().toLowerCase();
    if (!f) return items;
    return items.filter(p => `${p.code} ${p.description}`.toLowerCase().includes(f));
  }, [items, search]);

  const revenue = items.reduce((s, p) => s + (p.revenue || 0), 0);
  const sold = items.reduce((s, p) => s + (p.sold_qty || 0), 0);

  return (
    <div data-testid="contractor-products-page" className="space-y-6">
      <div>
        <h1 className="font-heading text-4xl font-black flex items-center gap-2"><Package weight="bold" /> Meus produtos</h1>
        <p className="text-sm text-brand-ink2 mt-1">Produtos cadastrados em seu nome e o que já foi vendido nas lives.</p>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <Stat label="Produtos" value={items.length} testid="ctr-products-count" />
        <Stat label="Peças vendidas" value={sold} testid="ctr-products-sold" />
        <Stat label="Faturamento" value={brl(revenue)} testid="ctr-products-revenue" />
      </div>
      <div className="relative">
        <MagnifyingGlass weight="bold" size={16} className="absolute left-3 top-1/2 -translate-y-1/2" />
        <input data-testid="ctr-products-search" className="input-brutal !pl-9" placeholder="Buscar código ou descrição…" value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>
      <div className="card-brutal overflow-x-auto bg-white">
        <table className="tbl w-full">
          <thead>
            <tr><th></th><th>Código</th><th>Descrição</th><th className="text-right">Preço</th><th className="text-right">Vendidos</th><th className="text-right">Faturamento</th></tr>
          </thead>
          <tbody>
            {!loading && visible.length === 0 && (
              <tr><td colSpan={6} className="text-center text-brand-ink2 py-8">Nenhum produto encontrado.</td></tr>
            )}
            {visible.map(p => (
              <tr key={p.id} data-testid={`ctr-product-row-${p.id}`}>
                <td>
                  {p.has_photo
                    ? <LazyImage src={`${API_BASE}/api/products/${p.id}/photo?w=96`} alt="" className="w-10 h-10 border-2 border-brand-ink" />
                    : <div className="w-10 h-10 border-2 border-brand-ink bg-brand-cream" />}
                </td>
                <td className="font-bold">{p.code}</td>
                <td>{p.description}</td>
                <td className="text-right">{brl(p.price)}</td>
                <td className="text-right">{p.sold_qty || 0}</td>
                <td className="text-right font-bold">{brl(p.revenue || 0)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Stat({ label, value, testid }) {
  return (
    <div className="card-brutal p-3 bg-white">
      <p className="label-brutal !mb-1">{label}</p>
      <p data-testid={testid} className="font-heading text-xl sm:text-2xl font-black">{value}</p>
    </div>
  );
}
